module.exports = __webpack_public_path__ + "ermilov-webfont.e6556187d823abc264d6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/ermilov-webfont.woff
// module id = ./src/assets/webfonts/ermilov-webfont.woff
// module chunks = styles